// CreatorProfileStep3.js
import { Box, Typography } from "@mui/material";
import MainContentReUse from "./MainContentReUse";
import TextFieldWithHeading from "./TextFieldWithHeading";
import Select from "react-select";
import countryList from "react-select-country-list";
import { useState, useMemo } from "react";
import api from "../../config/axios";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: "1px solid #000000",
    borderRadius: "8px",
    minHeight: "48px",
    height: "48px",
    boxShadow: state.isFocused ? "none" : provided.boxShadow,
    "&:hover": {
      border: "1px solid #000000",
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "48px",
    padding: "0 8px",
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    fontSize: "16px",
    color: "#12121299",
  }),
  placeholder: (provided) => ({
    ...provided,
    fontSize: "16px",
    color: "#12121299",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "16px",
    color: "#12121299",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "48px",
  }),
};

function CreatorProfileStep3({ onSuccess }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [country, setCountry] = useState(null);
  const options = useMemo(() => countryList().getData(), []);

  // When "Next Step" is clicked, call /api/auth/profile with { firstName, lastName, location }
  const handleNext = async () => {
    try {
      await api.put("/auth/profile", {
        firstName,
        lastName,
        location: country ? country.label : "",
      });
      onSuccess();
    } catch (err) {
      console.error("Profile update error:", err);
      alert(err?.response?.data?.message || "Error updating profile");
    }
  };

  return (
    <MainContentReUse
      primaryText="Influencer / Creator Profile"
      primaryButton={{ exist: true, text: "Next Step" }}
      secondaryText="Please fill out the following information about your influencer / creator activities"
      onClick={handleNext}
    >
      <Box sx={{ pt: "34px" }}>
        <TextFieldWithHeading
          heading="First Name"
          placeholder="John"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <TextFieldWithHeading
          heading="Last Name"
          placeholder="Doe"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <Box sx={{ mt: 2 }}>
          {/* Label for the dropdown */}
          <Typography
            variant="body2"
            sx={{
              fontSize: "17px",
              fontWeight: "400",
              lineHeight: "20.57px",
              mb: "4px",
              color: "#121212",
            }}
          >
            Country
          </Typography>
          <Select
            options={options}
            value={country}
            onChange={setCountry}
            placeholder="Select Country"
            styles={customStyles}
          />
        </Box>
      </Box>
    </MainContentReUse>
  );
}

export default CreatorProfileStep3;
